import { ReactNode, useEffect, useRef } from 'react';

// Tela cheia de mídia do Criar Conteúdo. No celular a mídia ocupava a tela inteira e não havia
// como sair: o ✕ ficava num painel abaixo da imagem (fora da tela) e o botão "voltar" do
// aparelho saía da página. Aqui o fechar é SEMPRE visível (canto superior, área segura do
// notch), Esc fecha, o voltar do aparelho fecha (entrada no histórico) e o fundo não rola.

export function MediaOverlay({ onClose, children, label = 'Mídia' }: { onClose: () => void; children: ReactNode; label?: string }) {
  const closeRef = useRef(onClose);
  closeRef.current = onClose;

  useEffect(() => {
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    // Voltar do aparelho/navegador fecha o overlay em vez de sair da tela.
    let closedByBack = false;
    window.history.pushState({ ...(window.history.state || {}), creativeOverlay: true }, '');
    const onPop = () => { closedByBack = true; closeRef.current(); };
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') closeRef.current(); };
    window.addEventListener('popstate', onPop);
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = prevOverflow;
      window.removeEventListener('popstate', onPop);
      window.removeEventListener('keydown', onKey);
      // Fechou pelo ✕/Esc/fundo: tira a entrada que empurramos, sem navegar para outro lugar.
      if (!closedByBack && window.history.state?.creativeOverlay) window.history.back();
    };
  }, []);

  return (
    <div role="dialog" aria-modal="true" aria-label={label} className="fixed inset-0 z-[60] flex items-center justify-center bg-black/90" onClick={onClose}>
      {children}
      <button
        type="button"
        onClick={e => { e.stopPropagation(); onClose(); }}
        aria-label="Fechar"
        className="absolute right-3 z-[61] flex h-11 w-11 items-center justify-center rounded-full bg-white/95 text-slate-800 shadow-lg active:scale-95"
        style={{ top: 'max(0.75rem, env(safe-area-inset-top))' }}
      >
        <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><path d="M18 6 6 18M6 6l12 12" /></svg>
      </button>
    </div>
  );
}
